import {Sprites} from '../ui_game/UIGameImageDictionary'
import {UIGameSpriteHandler} from '../UIGameSpriteHandler'
import {SpriteView} from './SpriteView'
import {PIXI} from '@colonist/pixi'

export class HighlightableSpriteView extends SpriteView {
    private readonly bgHighlight: SpriteView

    constructor(x: number, y: number, w: number, h: number, texture: PIXI.Texture, container: PIXI.Container, padding: number = 0) {
        super(x, y, w, h, container, texture, padding)

        const bgHighlightPadding = -0.2 * w / 2
        this.bgHighlight = new SpriteView(x, y, w, h, container, UIGameSpriteHandler.getTextureFromSpritesheet(Sprites.icon_highlight_circle), bgHighlightPadding)
        container.removeChild(this)
        container.addChild(this)
        this.highlight(false)
    }

    isHighlighted(): boolean {
        return this.bgHighlight.alpha === 1
    }

    highlight(active: boolean) {
        if(active && this.bgHighlight.alpha == 0) this.bgHighlight.alpha = 1
        if(!active && this.bgHighlight.alpha == 1) this.bgHighlight.alpha = 0
    }

    centerYInParent() {
        if(this.parent == undefined) return
        this.y = this.parent.height / 2 - this.height / 2
        this.bgHighlight.y = this.parent.height / 2 - this.bgHighlight.height / 2
    }

    centerXInParent() {
        super.centerXInParent()
        if(this.parent == undefined) return
        this.bgHighlight.x = this.parent.width / 2 - this.bgHighlight.width / 2
    }

    showView(parent: PIXI.Container) {
        if(this.bgHighlight.parent == undefined) parent.addChild(this.bgHighlight)
        if(this.parent == undefined) parent.addChild(this)
    }

    hideView() {
        if(this.parent != undefined) this.parent.removeChild(this)
        if(this.bgHighlight.parent != undefined) this.bgHighlight.parent.removeChild(this.bgHighlight)
    }

    updateTexture(texture: PIXI.Texture) {
        this.texture = texture
    }
}
